// SPDX-License-Identifier: AGPL-3.0-or-later

import {DebugModal, type DebugTab} from '@app/features/devtools/components/debug/DebugModal';
import type {GuildMember} from '@app/features/member/models/GuildMember';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface GuildMemberDebugModalProps {
	title: string;
	member: GuildMember;
}
export const GuildMemberDebugModal: React.FC<GuildMemberDebugModalProps> = observer(({title, member}) => {
	const {t} = useLingui();
	const recordJsonData = useMemo(() => member.toJSON(), [member]);
	const tabs: Array<DebugTab> = [
		{
			id: 'record',
			label: t`Community Member Record`,
			data: recordJsonData,
		},
	];
	return <DebugModal title={title} tabs={tabs} />;
});
